/*Import Estilo*/
import './index.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';
import MenuLateral from '../../../components/MenuLateral';

/*Import Requisição API*/
import api from '../../../api';
import { useToast } from '../../../context/ToastContext';

export default function Impostos() {
    const [abaAtiva, setAbaAtiva] = useState('empresa');
    const { showToast } = useToast();
    const navigate = useNavigate();
    const [modalAberto, setModalAberto] = useState(false);
    const [idProdutoParaExcluir, setIdProdutoParaExcluir] = useState(null);
    const caixaDeDialogo = useRef(null);
    const [termoPesquisa, setTermoPesquisa] = useState('');

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const abrirModalExcluir = (id_produto) => {
        setIdProdutoParaExcluir(id_produto);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };


    // Estados para Dados Fiscais da Empresa
    const [dadosEmpresa, setDadosEmpresa] = useState({
        razao_social: '',
        nome_fantasia: '',
        cnpj: '',
        inscricao_estadual: '',
        inscricao_municipal: '',
        cnae_principal: '',
        regime_tributario: 'Simples Nacional',
        endereco_cep: '',
        endereco_logradouro: '',
        endereco_numero: '',
        endereco_complemento: '',
        endereco_bairro: '',
        endereco_cidade: '',
        endereco_estado: '',
        responsavel_nome: '',
        responsavel_cpf: '',
        responsavel_telefone: '',
        responsavel_email: ''
    });

    // Estados para Configurações de Impostos
    const [configImpostos, setConfigImpostos] = useState({
        icms_aliquota_padrao: 18.00,
        icms_st_ativo: false,
        ipi_aliquota_padrao: 0.00,
        pis_aliquota: 1.65,
        cofins_aliquota: 7.60,
        iss_aliquota: 0.00
    });

    // Estados para ICMS por Estado
    const [icmsEstados, setIcmsEstados] = useState([]);

    // Estados para NCM Favoritos
    const [ncmFavoritos, setNcmFavoritos] = useState([]);
    const [novoNcm, setNovoNcm] = useState({
        codigo_ncm: '',
        descricao: '',
        uso_frequente: false
    });

    // Estados para Simulador
    const [simulacao, setSimulacao] = useState({
        valor_venda: '',
        estado_destino: 'SP',
        ncm: '',
        regime_tributario: 'Simples Nacional'
    });
    const [resultadoSimulacao, setResultadoSimulacao] = useState(null);
    const [simulacoes, setSimulacoes] = useState([]);

    // Estados para Produtos Fiscais
    const [produtosFiscais, setProdutosFiscais] = useState([]);
    const [produtoSelecionado, setProdutoSelecionado] = useState(null);

    // Estados para Checklist NF-e
    const [checklistNfe, setChecklistNfe] = useState(null);

    const [loading, setLoading] = useState(false);

    // Carregar dados iniciais
    useEffect(() => {
        if (abaAtiva === 'empresa') {
            carregarDadosEmpresa();
        } else if (abaAtiva === 'config') {
            carregarConfigImpostos();
        } else if (abaAtiva === 'tabelas') {
            carregarIcmsEstados();
            carregarNcmFavoritos();
        } else if (abaAtiva === 'simulador') {
            carregarSimulacoes();
        } else if (abaAtiva === 'produtos') {
            carregarProdutosFiscais();
        } else if (abaAtiva === 'nfe') {
            carregarChecklistNfe();
        }
    }, [abaAtiva]);

    // ========== FUNÇÕES DE CARREGAMENTO ==========
    const carregarDadosEmpresa = async () => {
        setLoading(true);
        try {
            const response = await api.get('/impostos/empresa');
            if (response.data.success) {
                setDadosEmpresa(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar dados da empresa', 'error');
        } finally {
            setLoading(false);
        }
    };

    const carregarConfigImpostos = async () => {
        setLoading(true);
        try {
            const response = await api.get('/impostos/config');
            if (response.data.success) {
                setConfigImpostos(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar configurações de impostos', 'error');
        } finally {
            setLoading(false);
        }
    };

    const carregarIcmsEstados = async () => {
        try {
            const response = await api.get('/impostos/icms-estados');
            if (response.data.success) {
                setIcmsEstados(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar ICMS por estado', 'error');
        }
    };

    const carregarNcmFavoritos = async () => {
        try {
            const response = await api.get('/impostos/ncm-favoritos');
            if (response.data.success) {
                setNcmFavoritos(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar NCM favoritos', 'error');
        }
    };

    const carregarSimulacoes = async () => {
        setLoading(true);
        try {
            const response = await api.get('/impostos/simulacoes');
            if (response.data.success) {
                setSimulacoes(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar simulações', 'error');
        } finally {
            setLoading(false);
        }
    };

    const carregarProdutosFiscais = async () => {
        setLoading(true);
        try {
            const response = await api.get('/impostos/produtos');
            if (response.data.success) {
                setProdutosFiscais(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar produtos fiscais', 'error');
        } finally {
            setLoading(false);
        }
    };

    const carregarChecklistNfe = async () => {
        setLoading(true);
        try {
            const response = await api.get('/impostos/checklist-nfe');
            if (response.data.success) {
                setChecklistNfe(response.data);
            }
        } catch (error) {
            showToast('Erro ao carregar checklist NF-e', 'error');
        } finally {
            setLoading(false);
        }
    };

    // ========== FUNÇÕES DE SALVAMENTO ==========
    const salvarDadosEmpresa = async () => {
        setLoading(true);
        try {
            const response = await api.put('/impostos/empresa', dadosEmpresa);
            if (response.data.success) {
                showToast('Dados da empresa atualizados com sucesso!', 'success');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao salvar dados', 'error');
        } finally {
            setLoading(false);
        }
    };

    const salvarConfigImpostos = async () => {
        setLoading(true);
        try {
            const response = await api.put('/impostos/config', configImpostos);
            if (response.data.success) {
                showToast('Configurações de impostos atualizadas!', 'success');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao salvar configurações', 'error');
        } finally {
            setLoading(false);
        }
    };

    const adicionarNcmFavorito = async () => {
        if (!novoNcm.codigo_ncm || !novoNcm.descricao) {
            showToast('Preencha código NCM e descrição', 'error');
            return;
        }

        try {
            const response = await api.post('/impostos/ncm-favoritos', novoNcm);
            if (response.data.success) {
                showToast('NCM adicionado aos favoritos!', 'success');
                setNovoNcm({ codigo_ncm: '', descricao: '', cest: '' });
                carregarNcmFavoritos();
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao adicionar NCM', 'error');
        }
    };

    const removerNcmFavorito = async (id) => {
        if (!window.confirm('Deseja remover este NCM dos favoritos?')) return;

        try {
            const response = await api.delete(`/impostos/ncm-favoritos/${id}`);
            if (response.data.success) {
                showToast('NCM removido dos favoritos!', 'success');
                carregarNcmFavoritos();
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao remover NCM', 'error');
        }
    };

    const simularImpostos = async () => {
        if (!simulacao.valor_venda || !simulacao.estado_destino) {
            showToast('Preencha valor de venda e estado de destino', 'error');
            return;
        }

        setLoading(true);
        try {
            const response = await api.post('/impostos/simular', simulacao);
            if (response.data.success) {
                setResultadoSimulacao(response.data.data);
                showToast('Simulação calculada com sucesso!', 'success');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao simular impostos', 'error');
        } finally {
            setLoading(false);
        }
    };

    const salvarSimulacaoAtual = async () => {
        if (!resultadoSimulacao) {
            showToast('Execute uma simulação primeiro', 'error');
            return;
        }

        try {
            const response = await api.post('/impostos/simulacao/salvar', {
                ...simulacao,
                ...resultadoSimulacao
            });
            if (response.data.success) {
                showToast('Simulação salva com sucesso!', 'success');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao salvar simulação', 'error');
        }
    };

    const atualizarProdutoFiscal = async () => {
        if (!produtoSelecionado) return;

        setLoading(true);
        try {
            const response = await api.put(`/impostos/produto/${produtoSelecionado.id}`, {
                ncm: produtoSelecionado.ncm,
                cest: produtoSelecionado.cest,
                cfop_dentro_estado: produtoSelecionado.cfop_dentro_estado,
                cfop_fora_estado: produtoSelecionado.cfop_fora_estado,
                origem_mercadoria: produtoSelecionado.origem_mercadoria,
                cst_icms: produtoSelecionado.cst_icms,
                aliquota_ipi: produtoSelecionado.aliquota_ipi
            });
            if (response.data.success) {
                showToast('Dados fiscais do produto atualizados!', 'success');
                setProdutoSelecionado(null);
                carregarProdutosFiscais();
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao atualizar produto', 'error');
        } finally {
            setLoading(false);
        }
    };

    const estadosBrasileiros = [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
        'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
        'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
    ];

    return (
        <section className="container-principal-impostos">
            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse produto?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim">
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModal}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>


            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <div className="container-conteudo-impostos">
                    <section className='conteudo-imposto'>
                        <div className="header-impostos">
                            <h1>Gerenciamento de Impostos</h1>
                            <span>Configuração fiscal e cálculo de tributos</span>
                        </div>

                        <div className="tabs-impostos">
                            <button
                                className={abaAtiva === 'empresa' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('empresa')}
                            >
                                Dados da Empresa
                            </button>
                            <button
                                className={abaAtiva === 'config' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('config')}
                            >
                                Configuração Impostos
                            </button>
                            <button
                                className={abaAtiva === 'tabelas' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('tabelas')}
                            >
                                Tabelas de Alíquotas
                            </button>
                            <button
                                className={abaAtiva === 'produtos' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('produtos')}
                            >
                                Produtos Fiscais
                            </button>
                            <button
                                className={abaAtiva === 'simulador' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('simulador')}
                            >
                                Simulador
                            </button>
                            <button
                                className={abaAtiva === 'nfe' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('nfe')}
                            >
                                Preparação NF-e
                            </button>
                        </div>

                        <div className="conteudo-aba-impostos">
                            {loading && <div className='loading'>
                                <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                                <h2>Carregando dados do fornecedor</h2>
                            </div>}
                            {abaAtiva === 'empresa' && !loading && (
                                <div className="aba-empresa">
                                    {/* Informações Fiscais */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>Informações Fiscais</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>Razão Social *</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.razao_social}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, razao_social: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Nome Fantasia</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.nome_fantasia}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, nome_fantasia: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>CNPJ (deixe em branco se ainda não tiver)</label>
                                                    <input
                                                        type="text"
                                                        placeholder="00.000.000/0000-00"
                                                        value={dadosEmpresa.cnpj}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, cnpj: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Inscrição Estadual</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.inscricao_estadual}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, inscricao_estadual: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>CNAE *</label>
                                                    <input
                                                        type="text"
                                                        placeholder="0000-0/00"
                                                        value={dadosEmpresa.cnae_principal}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, cnae_principal: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Regime Tributário *</label>
                                                    <div className='input-ativo'>
                                                        <select
                                                            value={dadosEmpresa.regime_tributario}
                                                            onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, regime_tributario: e.target.value })}
                                                        >
                                                            <option value="Simples Nacional">Simples Nacional</option>
                                                            <option value="Lucro Presumido">Lucro Presumido</option>
                                                            <option value="Lucro Real">Lucro Real</option>
                                                            <option value="MEI">MEI</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Endereço Fiscal */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>Endereço Fiscal</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>CEP</label>
                                                    <input
                                                        type="text"
                                                        placeholder="00000-000"
                                                        value={dadosEmpresa.endereco_cep}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, endereco_cep: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Logradouro</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.endereco_logradouro}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, endereco_logradouro: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Número</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.endereco_numero}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, endereco_numero: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Complemento</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.endereco_complemento}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, endereco_complemento: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Bairro</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.endereco_bairro}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, endereco_bairro: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Cidade</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.endereco_cidade}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, endereco_cidade: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Estado</label>
                                                    <div className='input-ativo'>
                                                        <select
                                                            value={dadosEmpresa.endereco_estado}
                                                            onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, endereco_estado: e.target.value })}
                                                        >
                                                            <option value="">Selecione...</option>
                                                            {estadosBrasileiros.map(uf => (
                                                                <option key={uf} value={uf}>{uf}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Representante Legal */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>Representante Legal</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>Nome Completo</label>
                                                    <input
                                                        type="text"
                                                        value={dadosEmpresa.responsavel_nome}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, responsavel_nome: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>CPF</label>
                                                    <input
                                                        type="text"
                                                        placeholder="000.000.000-00"
                                                        value={dadosEmpresa.responsavel_cpf}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, responsavel_cpf: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Telefone</label>
                                                    <input
                                                        type="text"
                                                        placeholder="(00) 00000-0000"
                                                        value={dadosEmpresa.responsavel_telefone}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, responsavel_telefone: e.target.value })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>E-mail</label>
                                                    <input
                                                        type="email"
                                                        value={dadosEmpresa.responsavel_email}
                                                        onChange={(e) => setDadosEmpresa({ ...dadosEmpresa, responsavel_email: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="btn-salvar" onClick={salvarDadosEmpresa}>
                                        Salvar Dados da Empresa
                                    </button>
                                </div>
                            )}

                            {/* ABA CONFIGURAÇÃO IMPOSTOS */}
                            {abaAtiva === 'config' && !loading && (
                                <div className="aba-config-impostos">
                                    {/* ICMS */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>ICMS - Imposto sobre Circulação de Mercadorias</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>Alíquota Padrão (%)</label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={configImpostos.icms_aliquota_padrao}
                                                        onChange={(e) => setConfigImpostos({ ...configImpostos, icms_aliquota_padrao: parseFloat(e.target.value) })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label className="checkbox-label">
                                                        <input
                                                            type="checkbox"
                                                            checked={configImpostos.icms_st_ativo}
                                                            onChange={(e) => setConfigImpostos({ ...configImpostos, icms_st_ativo: e.target.checked })}
                                                        />
                                                        ICMS-ST Ativo
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* PIS / COFINS */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>PIS / COFINS</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>Alíquota PIS (%)</label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={configImpostos.pis_aliquota}
                                                        onChange={(e) => setConfigImpostos({ ...configImpostos, pis_aliquota: parseFloat(e.target.value) })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Alíquota COFINS (%)</label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={configImpostos.cofins_aliquota}
                                                        onChange={(e) => setConfigImpostos({ ...configImpostos, cofins_aliquota: parseFloat(e.target.value) })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="btn-salvar" onClick={salvarConfigImpostos}>
                                        Salvar Configurações
                                    </button>

                                    {/* IPI / ISS */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>IPI / ISS</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>Alíquota IPI Padrão (%)</label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={configImpostos.ipi_aliquota_padrao}
                                                        onChange={(e) => setConfigImpostos({ ...configImpostos, ipi_aliquota_padrao: parseFloat(e.target.value) })}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label>Alíquota ISS (%)</label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={configImpostos.iss_aliquota}
                                                        onChange={(e) => setConfigImpostos({ ...configImpostos, iss_aliquota: parseFloat(e.target.value) })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="btn-salvar" onClick={salvarConfigImpostos}>
                                        Salvar Configurações
                                    </button>
                                </div>
                            )}

                            {/* ABA TABELAS */}
                            {abaAtiva === 'tabelas' && !loading && (
                                <div className="aba-tabelas">
                                    {/* ICMS por Estado */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>ICMS por Estado</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="tabela-icms-estados">
                                                {icmsEstados.map(item => (
                                                    <div key={item.id} className="item-icms-estado">
                                                        <strong>{item.estado}</strong>
                                                        <span>Interna: {item.aliquota_interna}%</span>
                                                        <span>Inter: {item.aliquota_interestadual}%</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {/* NCM Favoritos */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>NCM Favoritos</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="form-ncm">
                                                <div className="campo-ncm">
                                                    <label>Código NCM (8 dígitos)</label>
                                                    <input
                                                        type="text"
                                                        placeholder="00000000"
                                                        maxLength="8"
                                                        value={novoNcm.codigo_ncm}
                                                        onChange={(e) => setNovoNcm({ ...novoNcm, codigo_ncm: e.target.value })}
                                                    />
                                                </div>
                                                <div className="campo-ncm">
                                                    <label>Descrição</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Descrição"
                                                        value={novoNcm.descricao}
                                                        onChange={(e) => setNovoNcm({ ...novoNcm, descricao: e.target.value })}
                                                    />
                                                </div>
                                                <label className="checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        checked={novoNcm.uso_frequente}
                                                        onChange={(e) => setNovoNcm({ ...novoNcm, uso_frequente: e.target.checked })}
                                                    />
                                                    <span>Uso frequente</span>
                                                </label>
                                            </div>
                                            <button className="btn-adicionar-ncm" onClick={adicionarNcmFavorito}>Adicionar</button>

                                            <div className="lista-ncm-favoritos">
                                                {ncmFavoritos.map(ncm => (
                                                    <div key={ncm.id} className="card-ncm">
                                                        <h3>{ncm.codigo}</h3>
                                                        <p>{ncm.descricao}</p>
                                                        {ncm.uso_frequente ? <small>Uso frequente</small> : null}
                                                        <button onClick={() => removerNcmFavorito(ncm.id)}>Remover</button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ABA PRODUTOS FISCAIS */}
                            {abaAtiva === 'produtos' && !loading && (
                                <div className="aba-produtos-fiscais">
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>Dados Fiscais dos Produtos</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            {!produtoSelecionado ? (
                                                <div className="lista-produtos-fiscais">
                                                    {produtosFiscais.map(prod => (
                                                        <div key={prod.id} className="card-produto-fiscal" onClick={() => setProdutoSelecionado(prod)}>
                                                            <h3>{prod.nome}</h3>
                                                            <p>NCM: {prod.ncm || 'Não definido'}</p>
                                                            <p>CFOP: {prod.cfop_dentro_estado || 'Não definido'}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="form-produto-fiscal">
                                                    <button onClick={() => setProdutoSelecionado(null)}>← Voltar</button>
                                                    <h3>Editando: {produtoSelecionado.nome}</h3>
                                                    <div className="form-grid">
                                                        <div className="form-group">
                                                            <label>NCM *</label>
                                                            <input
                                                                type="text"
                                                                maxLength="8"
                                                                value={produtoSelecionado.ncm || ''}
                                                                onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, ncm: e.target.value })}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>CEST</label>
                                                            <input
                                                                type="text"
                                                                maxLength="7"
                                                                value={produtoSelecionado.cest || ''}
                                                                onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, cest: e.target.value })}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>CFOP Dentro do Estado</label>
                                                            <input
                                                                type="text"
                                                                maxLength="4"
                                                                value={produtoSelecionado.cfop_dentro_estado || ''}
                                                                onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, cfop_dentro_estado: e.target.value })}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>CFOP Fora do Estado</label>
                                                            <input
                                                                type="text"
                                                                maxLength="4"
                                                                value={produtoSelecionado.cfop_fora_estado || ''}
                                                                onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, cfop_fora_estado: e.target.value })}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>Origem da Mercadoria</label>
                                                            <div className='input-ativo'>
                                                                <select
                                                                    value={produtoSelecionado.origem_mercadoria || '0'}
                                                                    onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, origem_mercadoria: e.target.value })}
                                                                >
                                                                    <option value="0">0 - Nacional</option>
                                                                    <option value="1">1 - Estrangeira (Importação direta)</option>
                                                                    <option value="2">2 - Estrangeira (Mercado interno)</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="form-group">
                                                            <label>CST ICMS</label>
                                                            <input
                                                                type="text"
                                                                maxLength="2"
                                                                value={produtoSelecionado.cst_icms || ''}
                                                                onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, cst_icms: e.target.value })}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>Alíquota IPI (%)</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                value={produtoSelecionado.aliquota_ipi || 0}
                                                                onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, aliquota_ipi: parseFloat(e.target.value) })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {produtoSelecionado && (
                                            <div className="acao-secao-impostos">
                                                <button className="btn-salvar" onClick={atualizarProdutoFiscal}>Salvar</button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* ABA SIMULADOR */}
                            {abaAtiva === 'simulador' && !loading && (
                                <div className="aba-simulador">
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>Simulador de Impostos</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="form-simulador">
                                                <div className="form-grid">
                                                    <div className="form-group">
                                                        <label>Valor de Venda (R$) *</label>
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={simulacao.valor_venda}
                                                            onChange={(e) => setSimulacao({ ...simulacao, valor_venda: e.target.value })}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Estado de Destino *</label>
                                                        <div className='input-ativo'>
                                                            <select
                                                                value={simulacao.estado_destino}
                                                                onChange={(e) => setSimulacao({ ...simulacao, estado_destino: e.target.value })}
                                                            >
                                                                {estadosBrasileiros.map(uf => (
                                                                    <option key={uf} value={uf}>{uf}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="form-group">
                                                        <label>NCM (opcional)</label>
                                                        <input
                                                            type="text"
                                                            maxLength="8"
                                                            value={simulacao.ncm}
                                                            onChange={(e) => setSimulacao({ ...simulacao, ncm: e.target.value })}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Regime Tributário *</label>
                                                        <div className='input-ativo'>
                                                            <select
                                                                value={simulacao.regime_tributario}
                                                                onChange={(e) => setSimulacao({ ...simulacao, regime_tributario: e.target.value })}
                                                            >
                                                                <option value="Simples Nacional">Simples Nacional</option>
                                                                <option value="Lucro Presumido">Lucro Presumido</option>
                                                                <option value="Lucro Real">Lucro Real</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            {resultadoSimulacao && (
                                                <div className="resultado-simulacao">
                                                    <h3>Resultado da Simulação</h3>
                                                    <div className="grid-resultado">
                                                        <div className="item-resultado">
                                                            <span>Valor de Venda:</span>
                                                            <strong>R$ {resultadoSimulacao.valor_venda.toFixed(2)}</strong>
                                                        </div>
                                                        <div className="item-resultado icms">
                                                            <span>ICMS ({resultadoSimulacao.aliquota_icms}%):</span>
                                                            <strong>R$ {resultadoSimulacao.icms.toFixed(2)}</strong>
                                                        </div>
                                                        <div className="item-resultado pis">
                                                            <span>PIS ({resultadoSimulacao.aliquota_pis}%):</span>
                                                            <strong>R$ {resultadoSimulacao.pis.toFixed(2)}</strong>
                                                        </div>
                                                        <div className="item-resultado cofins">
                                                            <span>COFINS ({resultadoSimulacao.aliquota_cofins}%):</span>
                                                            <strong>R$ {resultadoSimulacao.cofins.toFixed(2)}</strong>
                                                        </div>
                                                        <div className="item-resultado total">
                                                            <span>Total de Impostos:</span>
                                                            <strong className="vermelho">R$ {resultadoSimulacao.total_impostos.toFixed(2)}</strong>
                                                        </div>
                                                        <div className="item-resultado liquido">
                                                            <span>Valor Líquido:</span>
                                                            <strong className="verde">R$ {resultadoSimulacao.valor_liquido.toFixed(2)}</strong>
                                                        </div>
                                                        <div className="item-resultado margem">
                                                            <span>Margem Líquida:</span>
                                                            <strong>{resultadoSimulacao.margem_liquida}%</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="acao-secao-impostos">
                                            <button className="btn-simular" onClick={simularImpostos}>
                                                Calcular Impostos
                                            </button>
                                            {resultadoSimulacao && (
                                                <button className="btn-salvar-simulacao" onClick={salvarSimulacaoAtual}>
                                                    Salvar Simulação
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {/* Histórico de Simulações */}
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>Histórico de Simulações</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="lista-simulacoes">
                                                {simulacoes.slice(0, 10).map((sim, idx) => (
                                                    <div key={idx} className="card-simulacao">
                                                        <p><strong>Valor:</strong> R$ {parseFloat(sim.valor_venda).toFixed(2)}</p>
                                                        <p><strong>Estado:</strong> {sim.estado_destino}</p>
                                                        <p><strong>Total Impostos:</strong> R$ {(parseFloat(sim.icms_calculado) + parseFloat(sim.pis_cofins_calculado || 0)).toFixed(2)}</p>
                                                        <p><strong>Líquido:</strong> R$ {parseFloat(sim.valor_liquido).toFixed(2)}</p>
                                                        <small>{new Date(sim.simulado_em).toLocaleDateString('pt-BR')}</small>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ABA PREPARAÇÃO NF-E */}
                            {abaAtiva === 'nfe' && !loading && checklistNfe && (
                                <div className="aba-nfe">
                                    <div className="conteudo-secao-impostos">
                                        <div className="cabecalho-secao-impostos">
                                            <h2>Preparação para Emissão de NF-e</h2>
                                        </div>
                                        <div className="dados-secao-impostos">
                                            <div className="checklist-nfe">
                                                <div className="progress-bar">
                                                    <div
                                                        className="progress-fill"
                                                        style={{ width: `${checklistNfe.checklist.progresso_total}%` }}
                                                    >
                                                        {checklistNfe.checklist.progresso_total}%
                                                    </div>
                                                </div>

                                                <div className="checklist-items">
                                                    <div className={`checklist-item ${checklistNfe.checklist.dados_preenchidos ? 'concluido' : ''}`}>
                                                        <label className="checkbox-label checkbox-static">
                                                            <input type="checkbox" disabled checked={checklistNfe.checklist.dados_preenchidos} />
                                                            <span>Dados da empresa preenchidos</span>
                                                        </label>
                                                    </div>
                                                    <div className={`checklist-item ${checklistNfe.checklist.cnpj_obtido ? 'concluido' : ''}`}>
                                                        <label className="checkbox-label checkbox-static">
                                                            <input type="checkbox" disabled checked={checklistNfe.checklist.cnpj_obtido} />
                                                            <span>CNPJ obtido e cadastrado</span>
                                                        </label>
                                                    </div>
                                                    <div className={`checklist-item ${checklistNfe.checklist.certificado_digital ? 'concluido' : ''}`}>
                                                        <label className="checkbox-label checkbox-static">
                                                            <input type="checkbox" disabled checked={checklistNfe.checklist.certificado_digital} />
                                                            <span>Certificado Digital A1 adquirido</span>
                                                        </label>
                                                    </div>
                                                    <div className={`checklist-item ${checklistNfe.checklist.integracao_sefaz ? 'concluido' : ''}`}>
                                                        <label className="checkbox-label checkbox-static">
                                                            <input type="checkbox" disabled checked={checklistNfe.checklist.integracao_sefaz} />
                                                            <span>Integração com SEFAZ configurada</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="info-nfe">
                                                <h3>O que é NF-e?</h3>
                                                <p>{checklistNfe.info.o_que_e_nfe}</p>

                                                <h3>Como obter Certificado Digital</h3>
                                                <p style={{ whiteSpace: 'pre-line' }}>{checklistNfe.info.como_obter_certificado}</p>

                                                <h3>Custos Estimados</h3>
                                                <p style={{ whiteSpace: 'pre-line' }}>{checklistNfe.info.custos_estimados}</p>

                                                <h3>Prazos</h3>
                                                <p style={{ whiteSpace: 'pre-line' }}>{checklistNfe.info.prazos}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            </main >

            <Rodape />
        </section >
    );
}
